import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Drawer,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";

interface PenaltiesProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  currentPenaltyIndex?: number | null;
}

const penalties = [
  { days: "less than 10 days ago", penalty: 30 },
  { days: "less than 20 days ago", penalty: 25 },
  { days: "less than 30 days ago", penalty: 20 },
  { days: "less than 60 days ago", penalty: 10 },
  { days: "less than 90 days ago", penalty: 5 },
  { days: "after 90 days", penalty: 0 },
];

export const PenaltiesModal = (props: PenaltiesProps) => {
  const { open, setOpen, currentPenaltyIndex } = props;
  const theme = useTheme();

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={() => setOpen(false)}
      ModalProps={{
        keepMounted: true,
        BackdropProps: {
          sx: {
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0,0,0,0.55)",
          },
        },
      }}
      PaperProps={{
        sx: {
          maxWidth: 980,
          mx: "auto",
          mb: { xs: 1, sm: 2 },
          borderTopLeftRadius: 3,
          borderTopRightRadius: 3,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: "background.paper",
          p: 3,
        },
      }}
    >
      <Box sx={{ mx: "auto", mb: 1.5, height: 6, width: 56, borderRadius: 999, bgcolor: "action.selected" }} />

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>Unstaking Penalties</Typography>
          <Typography variant="body2" color="text.secondary">
            Penalty decreases as staking duration increases.
          </Typography>
        </Box>
        <IconButton onClick={() => setOpen(false)} aria-label="Close penalties drawer">
          <CloseIcon />
        </IconButton>
      </Box>

      <Paper variant="outlined" sx={{ overflow: "hidden", borderRadius: 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Staking Duration</TableCell>
              <TableCell align="right" sx={{ fontWeight: 600 }}>Penalty</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {penalties.map((row, index) => (
              <TableRow
                key={row.days}
                sx={index === currentPenaltyIndex ? { bgcolor: "primary.main", "& td": { color: "primary.contrastText" } } : undefined}
              >
                <TableCell>{row.days}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>
                  {index === currentPenaltyIndex ? (
                    <Box component="span" sx={{ mr: 1, px: 1, py: 0.25, borderRadius: 99, fontSize: 10, fontWeight: 700, letterSpacing: 0.4, bgcolor: "rgba(0,0,0,0.22)", color: "inherit" }}>
                      YOU ARE HERE
                    </Box>
                  ) : null}
                  {row.penalty}%
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Drawer>
  );
};
